module.exports = __webpack_public_path__ + "static/media/waves.a3896bf8.png";